// extracted by mini-css-extract-plugin
export var locationCard = "_q1-0";